import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Group summary='Properties' mdxType="Group">
  <Item title='network' subtitle='String?' mdxType="Item">
    The human readable representation of card network (e.g., Visa, Mastercard).
  </Item>
  <Item title='cardholderName' subtitle='String?' mdxType="Item">
    The name of the cardholder.
  </Item>
  <Item title='first6Digits' subtitle='Int?' mdxType="Item">
    The first 6 digits of the card number.
  </Item>
  <Item title='last4Digits' subtitle='Int?' mdxType="Item">
    The last 4 digits of the card number.
  </Item>
  <Item title='accountNumberLast4Digits' subtitle='Int?' mdxType="Item">
    The last 4 digits of the account number.
  </Item>
  <Item title='expirationMonth' subtitle='Int?' mdxType="Item">
    The expiration month of the card, in 2-digit format.
  </Item>
  <Item title='expirationYear' subtitle='Int?' mdxType="Item">
    The expiration year of the card, in 4-digit format.
  </Item>
  <Item title='externalPayerInfo' subtitle='ExternalPayerInfo?' mdxType="Item">
    External information about the payer associated with the transaction.
    <Group summary='Properties' open mdxType="Group">
      <Item title='email' subtitle='String' mdxType="Item">
        The payer's email address.
      </Item>
      <Item title='externalPayerId' subtitle='String?' mdxType="Item">
        The payer's unique ID.
      </Item>
      <Item title='firstName' subtitle='String?' mdxType="Item">
        The payer's given name.
      </Item>
      <Item title='lastName' subtitle='String?' mdxType="Item">
        The payer's given surname.
      </Item>
    </Group>
  </Item>
  <Item title='klarnaCustomerToken' subtitle='String?' mdxType="Item" />
  <Item title='sessionData' subtitle='SessionData?' mdxType="Item" />
  <Item title='paymentMethodType' subtitle='String?' mdxType="Item">
    A unique string identifier for the payment method. (e.g. `PAYPAL`, `GOOGLE_PAY`)
  </Item>
  <Item title='binData' subtitle='BinData?' mdxType="Item">
    Additional BIN data.
    <Group summary='Properties' open mdxType="Group">
        <Item title='network' subtitle='String?' mdxType="Item">
           The card network (e.g., VISA, MASTERCARD, AMEX).
        </Item>
    </Group>
  </Item>
  <Item title='bankName' subtitle='String?' mdxType="Item">
    The name of the bank.
  </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      